import { createAction, props } from "@ngrx/store";
import { LocationTrackingDto } from "../interfaces/location_tracking";

export const upsertTracking = createAction(
    "[Tracking] Upsert Tracking",
    props<{ tracking: LocationTrackingDto }>()
);

export const upsertTrackingSuccess = createAction(
    "[Tracking] Upsert Tracking Success",
    props<{ tracking: LocationTrackingDto }>()
);

export const getTrackings = createAction(
    "[Tracking] Get Trackings"
);

export const getTrackingsSuccess = createAction(
    "[Tracking] Get Trackings Success",
    props<{ trackings: LocationTrackingDto[] }>()
)

export const getTrackingsByAppointmentId = createAction(
    "[Tracking] Get Trackings By Appointment Id",
    props<{ appointmentId: number }>()
);

export const getTrackingsByAppointmentIdSuccess = createAction(
    "[Tracking] Get Trackings By Appointment Id Success",
    props<{ trackings: LocationTrackingDto[] }>()
)

export const replaceTrackings = createAction(
    "[Tracking] Replace Trackings",
    props<{ oldTrackings: LocationTrackingDto[], newTrackings: Partial<LocationTrackingDto>[] }>()
);

export const replaceTrackingsSuccess = createAction(
    "[Tracking] Replace Trackings Success",
    props<{ trackings: LocationTrackingDto[] }>()
);

export const deleteTracking = createAction(
    "[Tracking] Delete Tracking",
    props<{ tracking: LocationTrackingDto }>()
);

export const deleteTrackingSuccess = createAction(
    "[Tracking] Delete Tracking Success",
    props<{ tracking: LocationTrackingDto }>()
);

export const startTracking = createAction(
    "[Tracking] Start Tracking",
    props<{ appointmentId: number }>()
)

export const stopTracking = createAction(
    "[Tracking] Stop Tracking"
)
